import {Platform} from 'react-native';

export type DeviceType = 'nativeMobile' | 'mobileBrowser' | 'desktopBrowser';

export function isMobileWebBrowser(): boolean {
  if (Platform.OS !== 'web') {
    return false;
  }

  const ua = navigator.userAgent || '';

  return /Android|iPhone|iPad|iPod|Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);
}

export function getDeviceType(): DeviceType {
  if (Platform.OS === 'ios' || Platform.OS === 'android') {
    return 'nativeMobile';
  }
  if (Platform.OS === 'web') {
    return isMobileWebBrowser() ? 'mobileBrowser' : 'desktopBrowser';
  }

  return 'desktopBrowser';
}
